import { Outlet } from 'react-router-dom';
import { TopBar } from '../components/pos/TopBar';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-[#F7FAFC] text-slate-900">
      <TopBar />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
